import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';

const CreateZone = ({ visible, handleClose, initialData = {}, onSubmit }) => {
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            zoneName: initialData?.zoneName || '',
        },
        validationSchema: Yup.object({
            zoneName: Yup.string().required('Zone Name is required'),
        }),
        onSubmit: (values, { resetForm }) => {
            if (initialData?.zoneId) {
                onSubmit({
                    sp: 'usp_UpdateZone',
                    ...values,
                    zoneId: initialData.zoneId,
                });
            } else {
                onSubmit({
                    sp: 'usp_InsertZone',
                    ...values,
                });
            }
            onClose();
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    return (
        <Modal
            title={initialData?.zoneName ? 'Edit Zone' : 'Create New Zone'}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={500}
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div role="document">
                    <div className="row g-3">
                        <div className="col-md-12">
                            <label className="form-label fs-7">Zone Name</label> <span className='text-danger'>*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter zone name"
                                name="zoneName"
                                value={formik.values.zoneName}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.zoneName && formik.errors.zoneName && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.zoneName}</span>
                            )}
                        </div>
                    </div>

                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-3">
                            {initialData?.zoneName ? 'Update' : 'Add'}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

CreateZone.propTypes = {
    visible: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    initialData: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
};

export default CreateZone;
